import { createContext, useContext, useMemo } from 'react';
import { DEFAULT_VIEW_ID_TO_ID_LABEL } from '../ViewTabs/constants/views';
import { jsx as _jsx } from "react/jsx-runtime";
const OUT_OF_CONTEXT_FLAG = 'OUT_OF_CONTEXT_FLAG';
const ListingContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
const ViewsPropsContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
const UiModePropsContext = /*#__PURE__*/createContext(OUT_OF_CONTEXT_FLAG);
export default function ListingProvider({
  children,
  enableObjectLevelPermissions,
  objectType,
  uiModeProps,
  viewProps,
  skipCrm,
  _useNonGqlCRMSearch
}) {
  const stableValue = useMemo(() => {
    return {
      enableObjectLevelPermissions,
      objectType,
      skipCrm,
      _useNonGqlCRMSearch
    };
  }, [enableObjectLevelPermissions, objectType, skipCrm, _useNonGqlCRMSearch]);
  const viewPropsWithIdLabel = useMemo(() => {
    if (!viewProps) {
      return undefined;
    }
    if (viewProps.currentViewId && DEFAULT_VIEW_ID_TO_ID_LABEL[viewProps.currentViewId]) {
      return Object.assign({}, viewProps, {
        currentViewId: DEFAULT_VIEW_ID_TO_ID_LABEL[viewProps.currentViewId]
      });
    }
    return viewProps;
  }, [viewProps]);
  return /*#__PURE__*/_jsx(ViewsPropsContext.Provider, {
    value: viewPropsWithIdLabel,
    children: /*#__PURE__*/_jsx(UiModePropsContext.Provider, {
      value: uiModeProps,
      children: /*#__PURE__*/_jsx(ListingContext.Provider, {
        value: stableValue,
        children: children
      })
    })
  });
}
export function useListing() {
  const context = useContext(ListingContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error('useListing must be used within a ListingProvider');
  }
  return context;
}
export function useViewProps() {
  const context = useContext(ViewsPropsContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error('useViewProps must be used within a ListingProvider');
  }
  return context;
}
export function useUiModeProps() {
  const context = useContext(UiModePropsContext);
  if (context === OUT_OF_CONTEXT_FLAG) {
    throw new Error('useUiModeProps must be used within a ListingProvider');
  }
  return context;
}